import { Navigate, createFileRoute } from "@tanstack/react-router";
import { stringParam } from "../../../lib/url-state";

/* Floor checks are Activity's Checks tab; this address opens it, keeping the open check. */
export const Route = createFileRoute("/_console/production/checks")({
  validateSearch: (search: Record<string, unknown>) => ({ check: stringParam(search.check) }),
  component: () => <Navigate to="/production/activity" search={{ view: "checks", check: Route.useSearch().check }} replace />,
});
